export enum EscalationActionType {
    CollectMeterInfoAtrias = 'collect-missing-meter-info-atrias',
    FillInFormFluviusForEanNumbers = 'fill-in-form-fluvius-for-ean-numbers',
    EnergyContractBookedAgain = 'energy-contract-booked-again',
    NewRequestRegularizationBill = 'new-request-regularization-bill',
    WaterTransferBookedAgain = 'water-transfer-booked-again',
    AskAColleague = 'ask-a-colleague',
}
